import { render, staticRenderFns } from "./SalonNuevo.vue?vue&type=template&id=0b629843&"
import script from "./SalonNuevo.vue?vue&type=script&lang=js&"
export * from "./SalonNuevo.vue?vue&type=script&lang=js&"
import style0 from "./SalonNuevo.vue?vue&type=style&index=0&id=0b629843&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports